import { helpers } from "@vuelidate/validators"

const url = requireHttps => async value => {
    if (!helpers.req(value)) {
        return true;
    }

    try {
        const parsed = new URL(value);
        return requireHttps
            ? parsed.protocol === "https:"
            : parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
        return false;
    }
}

export {
    url
}
